import React from 'react'

export const GiftIcon = (props) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill={props.fill || 'none'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_34_1645)'>
      <path
        d='M15 2C15.7023 1.99991 16.3922 2.18473 17.0004 2.53586C17.6086 2.88699 18.1137 3.39207 18.4647 4.00029C18.8158 4.60852 19.0006 5.29846 19.0005 6.00075C19.0003 6.70303 18.8153 7.3929 18.464 8.001L23 8V10H21V20C21 20.2652 20.8946 20.5196 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21H4C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5196 3 20.2652 3 20V10H1V8L5.536 8.001C5.03986 7.14189 4.88069 6.12906 5.08938 5.15917C5.29808 4.18929 5.85975 3.33157 6.66533 2.75255C7.47092 2.17354 8.46293 1.91455 9.44875 2.02588C10.4346 2.13721 11.3438 2.61091 12 3.355C12.3746 2.92838 12.8361 2.58677 13.3535 2.35308C13.8709 2.11938 14.4323 1.999 15 2ZM13 10H11V20H13V10ZM9 4C8.48102 3.99768 7.98145 4.19719 7.60685 4.55638C7.23224 4.91557 7.01193 5.40631 6.99246 5.92494C6.97299 6.44356 7.15588 6.94944 7.50249 7.33572C7.84911 7.72199 8.3323 7.9584 8.85 7.995L9 8H11V6C11 5.52206 10.8289 5.05991 10.5176 4.69726C10.2063 4.3346 9.77542 4.09541 9.303 4.023L9.149 4.005L9 4ZM15 4C14.4954 3.99984 14.0094 4.1904 13.6395 4.5335C13.2695 4.87659 13.0428 5.34684 13.005 5.85L13 6V8H15C15.5046 8.00016 15.9906 7.80959 16.3605 7.4665C16.7305 7.12341 16.9572 6.65315 16.995 6.15L17 6C17 5.46957 16.7893 4.96086 16.4142 4.58578C16.0391 4.21071 15.5304 4 15 4Z'
        fill={props.fill || 'currentColor'}
      />
    </g>
    <defs>
      <clipPath id='clip0_34_1645'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
